import {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useCallback,
} from "react";
import apiClient from "QueryClient/axiosClient";

const FavouritesContext = createContext(null);

const reducer = (state, action) => {
  switch (action.type) {
    case "SET":
      return action.payload;
    case "ADD":
      if (state.find((c) => c.id === action.payload.id)) return state;
      return [...state, action.payload];
    case "REMOVE":
      return state.filter((college) => college.id !== action.payload);
    default:
      return state;
  }
};

export const FavouritesProvider = ({ children }) => {
  const [favourites, dispatch] = useReducer(reducer, []);

  useEffect(() => {
    const fetchFavs = async () => {
      try {
        const res = await apiClient.get(`/users/getFavourites`);
        const data = Array.isArray(res.data)
          ? res.data
          : res.data.favourites ?? [];
        // @ts-ignore
        dispatch({ type: "SET", payload: data });
      } catch (err) {
        console.error("Failed to load favourites", err);
      }
    };
    fetchFavs();
  }, []);

  const addFavourite = useCallback(async (collegeId) => {
    try {
      const res = await apiClient.post(`/users/addToFavourites`, {
        collegeId,
      });

      // @ts-ignore
      dispatch({ type: "ADD", payload: res.data.college });
    } catch (err) {
      console.error("Failed to add favourite", err);
    }
  }, []);

  const removeFavourite = useCallback(async (collegeId) => {
    try {
      await apiClient.delete(`/users/removeFavourites`, {
        data: { collegeId },
      });

      // @ts-ignore
      dispatch({ type: "REMOVE", payload: collegeId });
    } catch (err) {
      console.error("Failed to remove favourite", err);
    }
  }, []);

  return (
    <FavouritesContext.Provider
      value={{ favourites, addFavourite, removeFavourite }}
    >
      {children}
    </FavouritesContext.Provider>
  );
};

export const useFavourites = () => {
  const context = useContext(FavouritesContext);
  if (!context) {
    throw new Error("useFavourites must be used within a FavouritesProvider");
  }
  return context;
};
